import { Link } from "react-router-dom";
import { useState } from "react";

function Navbar() {
  const [isMenuopen, setIsMenuopen] = useState(false);
  return (
    <header id="header" className="font-inter text-white py-6">
      <div
        id="navbar"
        className="navbar flex justify-between items-center w-[90%] mx-auto"
      >
        <div className=" w-[14%]">NexWallet</div>
        <ul className="hidden lg:flex items-center gap-3 self-center">
          <li className="list-none p-3 hover:bg-gradient-to-tr from-[#933FFE] to-[#18C8FF] rounded-lg transition-all cursor-pointer">
            <Link to="/nav-links">Buy / Sell</Link>
          </li>
          <li className="list-none p-3 hover:bg-gradient-to-tr from-[#933FFE] to-[#18C8FF] rounded-lg transition-all cursor-pointer">
            <Link to="/nav-links">Grow</Link>{" "}
          </li>
          <li className="list-none p-3 hover:bg-gradient-to-tr from-[#933FFE] to-[#18C8FF] rounded-lg transition-all cursor-pointer">
            <Link to="/nav-links">Markets</Link>{" "}
          </li>
          <li className="list-none p-3 hover:bg-gradient-to-tr from-[#933FFE] to-[#18C8FF] rounded-lg transition-all cursor-pointer">
            <Link to="/nav-links">Business</Link>{" "}
          </li>
          <li className="list-none p-3 hover:bg-gradient-to-tr from-[#933FFE] to-[#18C8FF] rounded-lg transition-all cursor-pointer">
            <Link to="/nav-links">Support</Link>{" "}
          </li>
        </ul>
        <div className="hidden lg:flex items-center justify-center gap-3">
          <button className="transition hover:translate-y-1 py-2 px-6 rounded-xl border border-white ">
            <Link to="/sign-in">Sign in</Link>
          </button>
          <button className="transition hover:translate-y-1 py-2 px-6 rounded-xl bg-gradient-to-tr from-[#933FFE] to-[#18C8FF] border border-[#933FFE]">
            <Link to="sign-up">Sign up</Link>
          </button>
        </div>
      </div>

      {/* Mobile Navbar */}
      <img
        className="absolute right-6 top-6 lg:hidden block cursor-pointer"
        src="/images/burger-menu1.png"
        alt="Menu"
        onClick={() => setIsMenuopen(!isMenuopen)}
      />

      <div
        className={`absolute xl:hidden top-24 left-0 w-full bg-gradient-to-tr from-[#933FFE] to-[#18C8FF] flex flex-col items-center z-20 text-lg gap-6 transform transition-transform ${
          isMenuopen ? "opacity-100" : "opacity-0"
        }`}
        style={{ transition: "transform 0.3s ease, opacity 0.3s ease" }}
      >
        <li className="list-none w-full text-center p-4 hover:bg-gradient-to-tr from-[#933FFE] to-[#18C8FF]">
          Buy / Sell
        </li>
        <li className="list-none w-full text-center p-4 hover:bg-gradient-to-tr from-[#933FFE] to-[#18C8FF]">
          Grow
        </li>
        <li className="list-none w-full text-center p-4 hover:bg-gradient-to-tr from-[#933FFE] to-[#18C8FF]">
          Markets
        </li>
        <li className="list-none w-full text-center p-4 hover:bg-gradient-to-tr from-[#933FFE] to-[#18C8FF]">
          Business
        </li>
        <li className="list-none w-full text-center p-4 hover:bg-gradient-to-tr from-[#933FFE] to-[#18C8FF]">
          Support
        </li>
      </div>
    </header>
  );
}

export default Navbar;
